import $ from 'jquery'

// JavaScript for disabling form submissions if there are invalid fields
$(document).ready(function() {
    'use strict'

    var $slider = $('#covid-slider');
    var $tabs = $slider.find('.tab');
    var $prev = $slider.find('.event-arrow-left');
    var $next = $slider.find('.event-arrow-right');

    var $currentTab = $tabs.first();

    $prev.click(function() {
        showPrevNextTab(-1);
    });
    $next.click(function() {
        showPrevNextTab(1);
    });

    function showPrevNextTab(n) {
        var $nextVisibleTab;
        if (n === -1) {
            $nextVisibleTab = $currentTab.prev('.tab');

            if ($nextVisibleTab.length === 0) {
                $nextVisibleTab = $tabs.last();
            }
        } else {
            $nextVisibleTab = $currentTab.next('.tab');

            if ($nextVisibleTab.length === 0) {
                $nextVisibleTab = $tabs.first();
            }
        }

        $currentTab.hide();
        $nextVisibleTab.show();

        $currentTab = $nextVisibleTab;

        $tabs.each(function() {
            $currentTab.parents('#sprekers').removeClass($(this).attr('data-for'));
        });

        $currentTab.parents('#sprekers').addClass($currentTab.attr('data-for'));
    }
});
